<template>
    <div class="article-terms-conditions">
        <h2>3.1 Event Registration</h2>
        <p>
            Our Events are not accessible to the general public and are for Swing Renegades Members only. In order to
            attend Our Events, individuals must be registered on this website and provide their real name and a valid
            email address belonging to them for the purposes of registration as a Swing Renegades Member. This need not
            be in advance of one of Our Events, as registration is possible on arrival at Our Events.
        </p>
        <p>
            In addition to registration, at each of Our Events that you attend, you must be checked in by a member of
            the Swing Renegades Team who will create a record that you have attended that particular event.
        </p>
        <h2>3.2 Dangerous Dancing</h2>
        <p>
            You may not dance at one of Our Events in a way which we believe may cause danger to other individuals in
            attendance at that event or yourself; this includes but is not limited to:
        </p>
        <ul>
            <li>Using a dangerous level of force to lead your partner.</li>
            <li>Following moves led by your partner in such a way as to cause a danger to your partner.</li>
            <li>Dancing without awareness and consideration of other dancers.</li>
            <li>Dancing in such a way as to risk your own health or safety.</li>
            <li>
                Performing aerial moves in which your or your partner's feet both leave the floor, in a dangerous manner
                or without the consent of your partner.
            </li>
        </ul>
        <h2>3.3 Unacceptable Behaviour</h2>
        <p>
            Inside or outside of Our Events, we consider the following behaviour to be unacceptable and a violation of
            our Terms and Conditions:
        </p>
        <ul>
            <li>
                Dancing in a way that is inappropriately close or in a manner that makes a Swing Renegades Member or a
                member of the Swing Renegades Team feel uncomfortable. Complaints of this manner are taken very
                seriously and may be referred to the Police.
            </li>
            <li>
                Assault, violence, harassment or intimidation directed towards a Swing Renegades Member or the Swing
                Renegades Team - which again may be referred to the Police.
            </li>
            <li>Derogatory comments directed towards a Swing Renegades Member or the Swing Renegades Team.</li>
        </ul>
        <p>
            If you believe that someone has violated this condition in any way, please discretely report this to a Swing
            Renegades Team member as a matter of urgency as we take these matters very seriously.
        </p>
        <h2>3.4 Promotion of External Events</h2>
        <p>
            The promotion of External Events at Our Events or within The Network - is strictly prohibited without the
            express permission of the Swing Renegades Team.
        </p>
        <p>
            This condition excludes the Swing Renegades Team, who are entitled to make decisions about which External
            Events may be promoted within Our Events and The Network.
        </p>
        <p>
            We reserve the right to exclude individuals from Our Events if we believe they are in attendance to promote
            an External Event.
        </p>
        <h2>3.5 Giving Feedback</h2>
        <p>
            Unless someone asks you for feedback about their dancing at one of Our Events, do not give feedback to Swing
            Renegades Members or attempt to teach them to dance yourself. The giving of feedback to another attendee of
            Our Events without their express permission is strictly forbidden. There are some subtleties to giving
            feedback, please see our
            <nuxt-link to="/blog/posts/the-dangers-of-giving-feedback">blog post</nuxt-link> for more info.
        </p>
        <h2>3.6 Discrimination &amp; Harassment</h2>
        <p>
            Swing Renegades is dedicated to providing inclusive and safe experiences for everyone, regardless of gender,
            sexual orientation, disability, physical appearance, body size, age, race, or religion. We do not tolerate
            harassment of members in any form. Members violating these rules will be excluded from Our Events and The
            Network.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleTermsConditions',
};
</script>
